/** @format */
import { css } from 'styled-components';

import { smallTablet } from '@toucan/client/global/application';

export const styles = css`
    display: flex;
    flex-direction: column;
    min-height: 0;
    padding: 0 var(--layout-spacing-24) var(--layout-spacing-24);

    ul {
        margin-top: var(--layout-spacing-8);
    }

    .option {
        margin-top: var(--layout-spacing-24);
        margin-bottom: 0;
    }

    .custom-range-inputs {
        display: flex;
        margin-top: var(--layout-spacing-8);
        padding: 0 var(--layout-spacing-24);
        gap: var(--layout-spacing-16);

        .input {
            margin-bottom: 0;

            input {
                padding-left: var(--layout-spacing-24);
            }

            input[value='']:not(:focus):not(:active) {
                & ~ .prefix {
                    color: var(--colors-text-tertiary);
                }
            }

            .prefix {
                width: 1.2rem;
                color: var(--colors-text-secondary);
                pointer-events: none;
            }
        }
    }

    ${smallTablet(css`
        .option {
            margin-top: 0;
        }

        ul {
            margin-left: var(--layout-spacing-24);
            margin-bottom: var(--layout-spacing-24);
        }

        .custom-range-inputs {
            flex-direction: column;
        }
    `)}
`;
